import { render, staticRenderFns } from "./FormGroupManage.vue?vue&type=template&id=7284d7d1"
import script from "./FormGroupManage.vue?vue&type=script&lang=js"
export * from "./FormGroupManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports